import { render, staticRenderFns } from "./ErrorCopiarInvitaciones.vue?vue&type=template&id=51b02bbc"
import script from "./ErrorCopiarInvitaciones.vue?vue&type=script&lang=js"
export * from "./ErrorCopiarInvitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports